import { useUserEventLogger } from '@repo/tracking-service';
import { Button, Guide, Title } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

import Illust2Logos from '@/assets/illust-icons/illust-2logos.svg';
import { COMMON_PATHS } from '@/lib/constants/paths';

const SimpleAuthSection = () => {
  const { sendClickEvent } = useUserEventLogger();
  const router = useRouter();

  const handleClickSimpleAuth = () => {
    sendClickEvent('indis-talk-decision_selectauth_simplecert');

    router.push({
      pathname: COMMON_PATHS.간편인증_정보입력,
      query: Object.assign({}, router.query, { from: 'alimtalk' })
    });
  };

  return (
    <div className="page-padding flex w-full flex-col">
      <Title.Headline title={`어떤 방법으로 진행할까요?`} size="large" />
      <div className="pb-8" />
      <Guide>
        <Guide.ImageArea>
          <Illust2Logos />
        </Guide.ImageArea>
        <Guide.TextArea>
          <Guide.Title titleType="large" className="text-gray-900">
            간편인증으로 진행하기
          </Guide.Title>
          <Guide.Description className="body-16">카카오톡, 네이버로 가능해요.</Guide.Description>
        </Guide.TextArea>
        <Guide.ButtonArea>
          <Button.Box size="large" state="primary" onClick={handleClickSimpleAuth}>
            바로 진행하기
          </Button.Box>
        </Guide.ButtonArea>
      </Guide>
    </div>
  );
};

export default SimpleAuthSection;
